import type { ReactNode } from 'react';

import { capitalizeFirstLetter } from 'utils/capitalize-first-letter';

import { userManagementSharedT as translations } from './translations';

type RoleLabelProps = {
  role: string;
};

type RoleConfig = {
  label: string;
  showReviewerBadge?: boolean;
};

const ROLE_INFO: Record<string, RoleConfig> = {
  admin_reviewer: {
    label: translations.roles.labels.admin,
    showReviewerBadge: true
  },
  operations_member_reviewer: {
    label: translations.roles.labels.operationsMember,
    showReviewerBadge: true
  },
  admin: {
    label: translations.roles.labels.admin
  },
  operations_member: {
    label: translations.roles.labels.operationsMember
  }
};

const humanizeRole = (value: string) =>
  value.split('_').map(capitalizeFirstLetter).join(' ');

const ApproverBadge = () => (
  <span className="ml-3 inline-flex items-center rounded-md bg-highlight-muted px-2 py-1 text-sm">
    {translations.roles.badges.reviewer}
  </span>
);

export const RoleLabel = ({ role }: RoleLabelProps): ReactNode => {
  const roleConfig = ROLE_INFO[role];

  if (!roleConfig) {
    return humanizeRole(role);
  }

  return (
    <span className="inline-flex items-center">
      {roleConfig.label}
      {roleConfig.showReviewerBadge && <ApproverBadge />}
    </span>
  );
};
